import React from 'react';
import {Image, Text, View} from "@react-pdf/renderer";
import signaturePNG from "assets/images/charlene.png";
import signaturePNG2 from "assets/images/nicole sigonly.png";
import moment from "moment";
import ConvertHTMLToPDF from "./ReportLanguage/ConvertHTMLToPDF";

export default ({data, ...props}) => {
  return (
    <View style={{
      //fontFamily: 'Poppins',
      fontSize: 7,
    }}>

      <ConvertHTMLToPDF html={data.language}/>

      <View
        style={{marginTop: 0, marginBottom: 0}}
        wrap={false}
      >
        {
          (data.testTypes.includes('M2') && data.testPerformedBy) && (
            <View style={{marginTop: 12}}>
              <Text>Test Performed by: {data.testPerformedBy}</Text>
            </View>
          )
        }
        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: 4,
          }}
        >
          <View>
            {
              data.testTypes.includes('M2') && (
                <Text>Test Reviewed by:</Text>
              )
            }
            <Image
              source={signaturePNG}
              style={{
                width: 3257 / 36,
                height: 1281 / 36,
              }}
              fixed
            />
            <Text>Charlene A Alouf, PhD HCLD MBA</Text>
            <Text>Clinical Laboratory Director</Text>
            <Text>Genomic Prediction Clinical Laboratory</Text>
          </View>
          <View>
            {
              data.testTypes.includes('M2') && (
                <Text> </Text>
              )
            }
            <Image
              source={signaturePNG2}
              style={{
                width: 2350 / 22,
                height: 703 / 22,
              }}
              fixed
            />
            <Text>Nicole E Faulkner PhD FACMG</Text>
            <Text> </Text>
            <Text> </Text>
          </View>
          <View>
            <Text>{moment(data.reportSigned).format("MM/DD/YYYY")}</Text>
          </View>
        </View>
      </View>

      <View style={{marginTop: 8, fontSize: 7}}>
        <Text>CAP: 8488628, CLIA: 31D2152380, New Jersey DOH: 00056206</Text>
      </View>
    </View>
  )
}
